import * as React from 'react'
import {
  ColumnDef,
  GetDataFunc,
  IdentifiableModel,
  PaginationOptions,
  Table,
} from 'cs-kevlar-react'
import { AuditEventSearchResult, AuditSearchSortValue } from '../../api'
import { serverDateToLocaleDateTimeString } from '../../utils'

export type Result = AuditEventSearchResult & IdentifiableModel

const TablePaginationOptions: Partial<PaginationOptions> = {
  singularAdjective: 'event',
  pluralAdjective: 'events',
}

export const ColumnMappings: {
  definition: ColumnDef<Result, string>
  sortValue?: AuditSearchSortValue | undefined
}[] = [
  {
    definition: {
      label: 'Date',
      sortable: true,
      sortByDefault: true,
      defaultSortOrder: 'desc',
      filterable: false,
      dataFunc: (p) => serverDateToLocaleDateTimeString(p.eventTimestamp),
    },
    sortValue: AuditSearchSortValue.EventTimestamp,
  },
  {
    definition: {
      label: 'Customer',
      sortable: true,
      sortByDefault: false,
      filterable: false,
      dataFunc: (p) => p.customerAgencyName,
    },
    sortValue: AuditSearchSortValue.CustomerAgencyName,
  },
  {
    definition: {
      label: 'Agency',
      sortable: true,
      sortByDefault: false,
      filterable: false,
      dataFunc: (p) => p.licensedAgencyName,
    },
    sortValue: AuditSearchSortValue.LicensedAgencyName,
  },
  {
    definition: {
      label: 'User',
      sortable: true,
      sortByDefault: false,
      filterable: false,
      dataFunc: (p) => p.byUsername,
    },
    sortValue: AuditSearchSortValue.ByUsername,
  },
  {
    definition: {
      label: 'Event',
      sortable: true,
      sortByDefault: false,
      filterable: false,
      dataFunc: (p) => p.eventTypeDescription,
    },
    sortValue: AuditSearchSortValue.EventType,
  },
]

const Columns: ColumnDef<Result, string>[] = ColumnMappings.map(
  (x) => x.definition,
)

export interface ResultsTableProps {
  getData: GetDataFunc<Result>
  selectedRow: Result | null
  onRowSelected: (row: Result) => void
}

export const ResultsTable: React.FunctionComponent<ResultsTableProps> = ({
  getData,
  selectedRow,
  onRowSelected,
}) => {
  return (
    <Table
      uniqueIdentifier="AuditSearchResults"
      ariaLabel="AuditSearchResults"
      data={getData}
      columns={Columns}
      selectedId={selectedRow?.id}
      onRowClicked={onRowSelected}
      paginationOptions={TablePaginationOptions}
      useDefaultRow
    />
  )
}
